import { CssBaseline, Grid, makeStyles } from '@material-ui/core'
import React from 'react'
import { TabTables } from '../ui/TabTables';

const useStyles = makeStyles((theme)=>({
    root: {
        display: 'flex',
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
        overflowX: 'hidden',
    },
    container: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(4),
        paddingLeft: theme.spacing(2),
    },
    paper: {  
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: 385,
        overflowY: 'hidden',
        overflowX: 'hidden',
    },
    
}))

export const TWSscreen = () => {
    const classes = useStyles();

    return (
        <>
            <CssBaseline />
            <main className={classes.content}>
                <div className={classes.appBarSpacer} />

                <Grid container  className={classes.container} >
                    {/* CRUD */}
                    <Grid item container spacing={3} xs={12} md={12} lg={12}>
                        <Grid item xs={12} md={12} lg={12}>
                            <TabTables />
                        </Grid>
                    </Grid>
                    
                           
                </Grid>
            </main>
        </>
    )
}
